<template>
  <div class="searchPanel">
    <div class="title">
      {{ title }}
    </div>
    <div>
      <div
        class="datePicker"
        @click="selectDate"
        :style="datePickerStyle"
        v-if="!isSearchByCity">
        {{ searchDate ? searchDate : '选择日期' }}
      </div>
      <input
        type="text"
        :placeholder="placeholder"
        class="searchInput"
        v-if="!isSearchByCity"
        v-model="travelNumberInput">
      <input
        type="text"
        placeholder="请输入城市名，如 武汉"
        class="searchInput"
        v-if="isSearchByCity"
        @input="inputCity"
        :value="city">
    </div>
    <div class="search" @click="search">
      开始查询
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex';

  export default {
    props : [ 'searchType' ],

    data() {
      return {
        travelNumberInput : ''
      };
    },

    computed : {
      ...mapState( 'virusTrip', [ 'searchDate', 'travelNumber', 'city' ] ),

      isSearchByCity() {
        return this.searchType === 'city';
      },

      title() {
        let result;

        if ( this.isSearchByCity ) {
          result = '请输入城市名';
        } else {
          result = '请选择一项或多项';
        }

        return result;
      },

      placeholder() {
        let result;

        if ( this.searchType === 'train' ) {
          result = '输入车次，如 G127'
        } else if ( this.searchType === 'flight' ) {
          result = '输入航班号，如 CA1831'
        }

        return result;
      },

      datePickerStyle() {
        let result;

        if ( this.searchDate ) {
          result = {
            color : '#000000'
          };
        } else  {
          result = {
            color : '#808080'
          };
        }

        return result;
      }
    },

    methods : {
      ...mapMutations( 'virusTrip', [
        'updateSearchDate', 'updateTravelNumber', 'updateCity'
      ] ),

      selectDate() {
        this.$router.push( {
          name : 'pages/calendar',

          params : {
            onSelect : this.onSelectDate
          }
        } );
      },

      onSelectDate( date ) {
        this.updateSearchDate( date );
      },

      inputTravelNumber( travelNumber ) {
        this.updateTravelNumber( travelNumber );
      },

      inputCity( e ) {
        this.updateCity( e.target.value );
      },

      search() {
        if ( this.searchType === 'flight' || this.searchType === 'train' ) {
          const travelNumber = this.travelNumber;

          if ( travelNumber.trim() !== travelNumber.replace( /\s/g, '' ) ) {
            this.$popup( {
              content : '请输入正确的航班号或车次号'
            } );

            return;
          }
        }

        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        ha( 'send', 'click', {
          eventId : 'search_num',
          bizsys  : 'bjyf',
          actId   : 'fy_transport',

          eventAttr : JSON.stringify( {
            type        : this.searchType,
            search_date : this.searchDate,
            search_num  : this.travelNumber,
            source      : ptid
          } )
        } );

        this.$router.push( {
          path : '/virusTrip/searchResult',

          query : {
            searchType   : this.searchType,
            searchDate   : this.searchDate,
            travelNumber : this.travelNumber,
            city         : this.city
          }
        } );
      }
    },

    watch : {
      travelNumberInput : function( newValue ) {
        this.inputTravelNumber( newValue );
      },

      travelNumber : function( newValue ) {
        this.travelNumberInput = newValue;
      }
    },

    mounted() {
      if ( this.travelNumber ) {
        this.travelNumberInput = this.travelNumber;
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "./search-panel.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/search/search-panel.vue